import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm.5-6.5v-1.376a1.5 1.5 0 0 1 .97-1.404l.07-.027A4 4 0 1 0 8 10a.5.5 0 1 0 1 0 3 3 0 1 1 4.155 2.77l-.037.014a2.5 2.5 0 0 0-1.618 2.34V16.5a.5.5 0 1 0 1 0zM12 19a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
});

var SvgHelpFilled = function SvgHelpFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgHelpFilled;